import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getUserWithFilter as asyncGetUserWithFilter,
  updateUserStatus as asyncUpdateUserStatus,
  deleteUser as asyncDeleteUser,
  bulkDeleteUser as asyncBulkDeleteUser,
} from "../../helpers/apis";
import { showToast } from "../toast/reducer";

// Thunk for fetching users with filter
export const getUserWithFilter = createAsyncThunk(
  "getUserWithFilter",
  async (req, thunkAPI) => {
    try {
      const response = await asyncGetUserWithFilter(req);
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error.msg }));
      throw error;
    }
  }
);


// Thunk for updating a user
export const updateUserStatus = createAsyncThunk(
  "updateUser",
  async (data, thunkAPI) => {
    try {
      const response = await asyncUpdateUserStatus(data);
      thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error.msg || error.message || "Error updating status" }));
      throw error;
    }
  }
);

// Thunk for deleting a user
export const deleteUser = createAsyncThunk(
  "deleteUser",
  async (req, thunkAPI) => {
    try {
      const response = await asyncDeleteUser(req);
      thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error.msg }));
      throw error;
    }
  }
);

// Thunk for bulk deleting users
export const bulkDeleteUser = createAsyncThunk(
  "bulkDeleteUser",
  async (data, thunkAPI) => {
    try {
      const response = await asyncBulkDeleteUser(data);
      thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
      return data.userIds;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(showToast({ type: "error", msg: error.msg }));
      throw error;
    }
  }
);
